<template>
  <div class="sportMarketsContainer">
    <v-row v-if="sportEvent">
      <v-col md="12">
        <v-toolbar class="mb-3" height="80px">
          <div>
          <h4>{{ sportEvent }}</h4>
          <h5>{{ sportEventId }}</h5>
          <h5>{{ sportDate }}</h5>
         </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row v-if="sportMarkets[0].length > 0 || sportMarkets[1].length > 0">
      <v-col md="6">
        <v-toolbar class="mb-3" height="30px">
          <h4>Open</h4>
        </v-toolbar>
        <div
          v-for="sportMarket in sportMarkets[0]"
          :key="sportMarket.id"
          class="market"
        >
          <v-btn
            small
            outlined
            @click="getResultSelections(sportMarket.name)"
          >
            <!-- <v-icon color="success" v-if="i % 2 == 0">mdi-check-circle</v-icon>
            <v-icon color="error" v-else>mdi-close-circle</v-icon> -->
            {{ sportMarket.name }}
          </v-btn>
        </div>
      </v-col>
      <v-col md="6">
        <v-toolbar class="mb-3" height="30px">
          <h4>Resulted</h4>
        </v-toolbar>
        <div
          v-for="sportMarket in sportMarkets[1]"
          :key="sportMarket.id"
          class="market"
        >
          <v-btn
            small
            outlined
          >
            <!-- <v-icon color="success" v-if="i % 2 == 0">mdi-check-circle</v-icon>
            <v-icon color="error" v-else>mdi-close-circle</v-icon> -->
            {{ sportMarket.name }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data: () => ({ }),
  computed: {
    ...mapGetters(['getSportMarkets', 'getSportEvent']),
    sportMarkets () {
      const markets = this.getSportMarkets

      markets.sort(function(a, b){
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
      })

      const marketsOpen = markets.filter(market => market.status === 'Open')
      const marketsResulted = markets.filter(market => market.status === 'Result')

      return [marketsOpen, marketsResulted]
    },
    sportEvent () {
        const eventName = this.getSportEvent?.name
        return eventName
    },
    sportEventId () {
      const sportEventId = "eventId " +
      this.getSportEvent?.id
      return sportEventId
    },
    sportDate () {
      const date =  "startDate " + new Date(this.getSportEvent.start_date)
      return date
    }
  },
  methods: {
    ...mapActions(['fetchSportResultSelections']),
    getResultSelections (sportMarketName) {
      this.fetchSportResultSelections({ sportMarketName: sportMarketName })
    }
  }
}
</script>

<style>
  .sportMarketsContainer {
    background-color: #fff;
    padding: 36px;
  }

  .market {
    margin-right: 12px;
    margin-bottom: 12px;
  }
</style>
